export enum ContactMessageType {
  Undefined = 0,
  Mail = 10,
  Phone = 20,
}
